import Splide from '@splidejs/splide';

export default () => {
  const publicationsSliders = document.querySelectorAll('.slider-publications');

  if (!publicationsSliders.length) {
    return;
  }

  const sliders = [];

  publicationsSliders.forEach(slider => {
    const sliderData = slider.dataset,
          sliderId = sliderData.id,
          sliderItems = parseInt(sliderData.items);

    const publicationsSlider = new Splide(slider, {
      type: (sliderItems >= 4) ? 'loop' : 'slide',
      perPage: 1,
      gap:'10px',
      perMove: 1,
      arrows: false,
      pagination: false,
      height:'421px',
      padding:{
        right:'55px'
      },
      mediaQuery: 'min',
      breakpoints: {
        768: {
          perPage: 2,
        },
        1200: {
          perPage: 3,
          height:'494px',
          gap:'10px',
          padding:{
            right:'90px'
          },
        },
        1750: {
          height:'544px'
        }
      }
    });

    sliders.push(publicationsSlider);

    publicationsSlider.mount();
  
    const navigation = document.querySelector(`#publications-slider-navigation-${sliderId}`);

    if (!navigation) {
      return; 
    }      
  
    const btnNext = navigation.querySelector('.publications-slider-btn-next'),
          btnPrev = navigation.querySelector('.publications-slider-btn-prev');
  
    btnNext?.addEventListener('click', e => {
      publicationsSlider.go('+1')
    })
  
    btnPrev?.addEventListener('click', e => {
      publicationsSlider.go('-1')
    })
  });

  const tabs = document.querySelectorAll('.publications-slider-navigation-tabs .nav-link');

  if (!tabs.length || !sliders.length) {
    return;
  }

  const sliderRefresh = (sliderId) => {
    sliders.find(slider => {
      if (sliderId !== slider._o.sliderId) {
        return;
      }

      slider.refresh();
    })
  }

  const tabSliderListener = (e) => sliderRefresh(e.target.dataset.sliderId)

  tabs.forEach(tab => tab.addEventListener('click', tabSliderListener));

}
